import * as React from "react";
import { Button, HStack, Icon, Text } from "@chakra-ui/react";
import { IoPauseCircle, IoPlayCircle } from "react-icons/io5";
import { getTimerValue } from "duck";
import { useDentalChart } from "../../../../duck";
import { usePreventReload, useTimer } from "./duck";

const Timer: React.FC = () => {
  const dentalChart = useDentalChart();

  const { toggle, running, extraSec } = useTimer();

  usePreventReload({ enabled: running });

  if (!dentalChart) {
    return null;
  }

  const totalTimeSec = dentalChart.timerDurationSec + extraSec;

  return (
    <HStack spacing="12px" mb="24px" alignItems="center">
      <Text>{getTimerValue(totalTimeSec)}</Text>
      <Button
        variant="unstyled"
        alignItems="center"
        justifyContent="center"
        display="inline-flex"
        onClick={toggle}
        w="24px"
        h="24px"
      >
        <Icon as={running ? IoPauseCircle : IoPlayCircle} boxSize="24px" />
      </Button>
    </HStack>
  );
};

export default Timer;
